import React from "react";
import {Button} from "react-bootstrap";
import ClientTable from "../ClientTable";

export default ({event, answer, onClose}) => {
    return (
        <section>
            <Button onClick={onClose}>Назад</Button>
            <ClientTable
                clients={answer.client}
                event={event}
                full
                hideButtons
            />
        </section>
    );
}
